/**
 * Street prefixes written in full in addresses („ul.” → „ulica”). Without imports,
 * so the noise layer and its test, which loads the layer from source, can use it
 * as well as utils/formatters.js.
 */
const ADDRESS_PREFIXES = [[/(^|[\s,(])ul\.\s*/gi, 'ulica '], [/(^|[\s,(])al\.\s*/gi, 'aleja '], [/(^|[\s,(])pl\.\s*/gi, 'plac '], [/(^|[\s,(])os\.\s*/gi, 'osiedle ']];

export function expandAddressAbbreviations(text) {
    let value = String(text == null ? '' : text);
    ADDRESS_PREFIXES.forEach((rule) => {
        value = value.replace(rule[0], (match, lead) => lead + rule[1]);
    });
    return value;
}
